import {rootNavbarEl, setRootNavbarEl} from '../helpers'

const smartHeader = () => {
	if (rootNavbarEl) {
		const handleNavScroll = () => {
			window.pageYOffset > 80 ? rootNavbarEl.classList.add('sticky') : rootNavbarEl.classList.remove('sticky')
		}

		window.addEventListener("scroll", handleNavScroll)
		window.addEventListener("resize", handleNavScroll)
	}
}
export default smartHeader
